import "whatwg-fetch";
import "core-js";
import "raf/polyfill";

import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import Raven from "raven-js";

import { I18nextProvider } from "react-i18next";
import i18n from "./utils/i18n/i18n";

import store, { history } from "./stores";
import { unregister } from "./registerServiceWorker";

import { setupAxios, setupRaven } from "./utils/config";
import { attemptAxiosApiSetup } from "./utils/api";

import "./assets/styles/index.scss";
import "react-daterange-picker/dist/css/react-calendar.css";

import App from "./containers/app";

const target = document.querySelector("#root");

setupAxios();
setupRaven();
attemptAxiosApiSetup();

Raven.context(() => {
  render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </ConnectedRouter>
    </Provider>,
    target
  );
});

unregister();

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();

    if (caches) {
      // Service worker cache should be cleared with caches.delete()
      caches.keys().then(async (names) => {
        await Promise.all(names.map((name) => caches.delete(name)));
      });
    }
  });
}
